@if (data?.styles) {
    @if (data.styles.showSectionHeading) {
        <h2
            [id]="id + 'top'"
            [ngStyle]="{
                'font-family': data.styles.sectionHeading.fontFamily,
                'color': data.styles.sectionHeading.color,
                'font-weight': data.styles.sectionHeading.bold ? 'bold' : 'normal',
                'font-size': data.styles.sectionHeading.fontSize,
                'font-style': data.styles.sectionHeading.italics ? 'italic' : 'normal',
                'text-decoration': data.styles.sectionHeading.underlined ? 'underline' : 'none',
                'text-align': data.styles.sectionHeading.alignment,
                'display': 'block',
                'line-height': '100%',
            }"
        >
            {{ data.title }}
        </h2>
    }

    @if (mentions.length === 0) {
        <div class="agpr-mentionGridDisplay-container--placeholder">
            <agpr-message
                [severity]="severity.noContent"
            >{{ 'Monitoring.result.noContentFound' | localize }}</agpr-message>
        </div>
    } @else {
        <div
            #container
            class="agpr-mentionGridDisplay-container"
            [ngStyle]="{
                'padding-top': data?.styles?.padding?.paddingOption
                        ? (data.styles?.padding.topPadding) + 'px'
                        : (data.styles?.padding.paddingAll) + 'px',
                'padding-right': data?.styles?.padding?.paddingOption
                    ? (data.styles?.padding.rightPadding) + 'px'
                    : (data.styles?.padding.paddingAll) + 'px',
                'padding-bottom': data?.styles?.padding?.paddingOption
                    ? (data.styles?.padding.bottomPadding) + 'px'
                    : (data.styles?.padding.paddingAll) + 'px',
                'padding-left': data?.styles?.padding?.paddingOption
                    ? (data.styles?.padding.leftPadding) + 'px'
                    : (data.styles?.padding.paddingAll) + 'px',
                'background-color': data.styles.backgroundColor,
            }"
        >
            <div class="agpr-mentionGridDisplay-topLinks">
                <!-- Get insights link -->
                <!-- @if (data.includeInsightsLink || data.viewInBrowserInsightUrl) {
                    <a
                        class="agpr-mentionGridDisplay-viewAllLink"
                        [ngStyle]="{
                            'font-family': data.styles.mentionInsightsLinkFont.fontFamily,
                            'color': data.styles.mentionInsightsLinkFont.color,
                            'font-weight': data.styles.mentionInsightsLinkFont.bold ? 'bold' : 'normal',
                            'font-size': data.styles.mentionInsightsLinkFont.fontSize,
                            'font-style': data.styles.mentionInsightsLinkFont.italics ? 'italic' : 'normal',
                            'text-decoration': data.styles.mentionInsightsLinkFont.underlined ? 'underline' : 'none',
                        }"
                        [href]="data.viewInBrowserInsightUrl"
                        target="_blank"
                    >
                        <span> {{ data.styles.mentionInsightsLinkLabel }} </span>
                        <i class="fa fa-external-link"></i>
                    </a>
                } -->

                <a
                    class="agpr-mentionGridDisplay-viewAllLink"
                    (click)="viewAllMentions()"
                    [ngStyle]="{'color': data.styles?.heading.color}"
                >
                    <span> {{ 'Briefings.mentionList.viewMentionLink' | localize }} </span>
                    <i class="fa-regular fa-layer-group"></i>
                </a>
            </div>

            <ul class="agpr-mentionGridDisplay" [ngClass]="gridClass">
                @for (mention of mentions; track i; let i = $index;) {
                    @let mentionId = mention.id || mention.mercuryId;
                    <li
                        class="agpr-mentionGridDisplay-card"
                        [id]="id + '-mention-' + i"
                        [ngClass]="{
                            'agpr-mentionGridDisplay-card-fullHeight': data?.styles?.cardHeight !== mentionCardHeightEnum.flexible
                        }"
                    >
                        <div class="agpr-mentionGridDisplay-cardContainer">
                            <!-- OUTLET -->
                            <div class="agpr-mentionGridDisplay-topRow">
                                <div class="agpr-mentionGridDisplay-outlet">
                                    @if (data.styles.outletIcon) {
                                        @if (mention.outletAvatarUrl) {
                                            <img
                                                class="agpr-mentionGridDisplay-outletImage"
                                                alt="Outlet Image"
                                                [src]="mention.outletAvatarUrl"
                                            />
                                        } @else if (mention.outletName) {
                                            <div class="agpr-mentionGridDisplay-outletImage agpr-mentionGridDisplay-outletImagePlaceholder">
                                                <span>{{ mention.outletName.charAt(0) }}</span>
                                            </div>
                                        } @else if (avatarPlaceholderTextMap[mentionId]) {
                                            <div class="agpr-mentionGridDisplay-outletImage agpr-mentionGridDisplay-outletImagePlaceholder">
                                                <span>{{ avatarPlaceholderTextMap[mentionId] }}</span>
                                            </div>
                                        }
                                    }
                                    @if (data.styles.metadataTypes.includes(metadataTypes.outlet)) {
                                        <div
                                            [ngStyle]="{
                                                'text-align': data.styles.metadataFont.alignment,
                                                'font-weight': data.styles.metadataFont.bold ? 'bold' : 'normal',
                                                'color': data.styles.metadataFont.color,
                                                'font-family': data.styles.metadataFont.fontFamily,
                                                'font-size': data.styles.metadataFont.fontSize,
                                                'font-style': data.styles.metadataFont.italics ? 'italic' : 'normal',
                                                'text-decoration': data.styles.metadataFont.underlined ? 'underline' : 'none',
                                            }"
                                        >
                                            {{ mention.outletName }}
                                        </div>
                                    }
                                </div>
                                @if (data.styles.metadataTypes.includes(metadataTypes.mediaType)) {
                                    <div class="agpr-mentionGridDisplay-mediaType">
                                        <span
                                            role="img"
                                            class="agpr-mentionGridDisplay-mediaTypeIcon"
                                            [ngClass]="mediaTypeIconMap.get(mention.mediaType)"
                                            [agprTooltip]="'MediaType.'+ mention.mediaType | localize"
                                            tooltipPosition="top"
                                        ></span>
                                    </div>
                                }

                            </div>
                            @if (mention?.isTranslatedPreferred && !!mention.translation) {
                                <div class="agpr-mentionGridDisplay-mentionLanguage-label">
                                    <span>{{ 'Mention.translated' | localize }}: </span>
                                    {{ (mention?.language ? 'Language.' + mention?.language : 'Language.en') | localize }}
                                    <span  aria-hidden="true" class="agpr-mentionGridDisplay-mentionLanguage-arrow fa-regular fa-arrow-right"></span>
                                    <span>
                                        {{ ('Language.' + mention?.translation?.language | localize) }}
                                    </span>
                                </div>
                            }

                            <!-- HEADLINE -->
                            @if (mention.url) {
                                <a
                                    [href]="mentionUrlMap[mentionId]"
                                    target="_blank"
                                    class="agpr-mentionGridDisplay-headline"
                                    [style.text-decoration]="data.styles.underlineLinks ? 'underline' : 'none'"
                                >
                                    <ng-container *ngTemplateOutlet="headline"></ng-container>
                                </a>
                            } @else {
                                <ng-container *ngTemplateOutlet="headline"></ng-container>
                            }
                            <ng-template #headline>
                                @if (mention.title || (mention.isTranslatedPreferred && mention.translation.headline)) {
                                    <span
                                        class="agpr-mentionGridDisplay-headline"
                                        [ngStyle]="{
                                            'text-align': data.styles.heading.alignment,
                                            'font-weight': data.styles.heading.bold ? 'bold' : 'normal',
                                            'color': data.styles.heading.color,
                                            'font-family': data.styles.heading.fontFamily,
                                            'font-size': data.styles.heading.fontSize,
                                            'font-style': data.styles.heading.italics ? 'italic' : 'normal',
                                            'text-decoration': data.styles.heading.underlined ? 'underline' : 'none',
                                            'line-height': '1.5'
                                        }"
                                    >
                                        {{ mention.isTranslatedPreferred ? (mention.translation.headline || mention.title) : mention.title }}
                                    </span>
                                } @else {
                                    <span
                                        class="agpr-mentionGridDisplay-headline"
                                        [ngStyle]="{
                                            'text-align': data.styles.heading.alignment,
                                            'font-weight': data.styles.heading.bold ? 'bold' : 'normal',
                                            'color': data.styles.heading.color,
                                            'font-family': data.styles.heading.fontFamily,
                                            'font-size': data.styles.heading.fontSize,
                                            'font-style': data.styles.heading.italics ? 'italic' : 'normal',
                                            'text-decoration': data.styles.heading.underlined ? 'underline' : 'none',
                                            'display': 'block',
                                            'line-height': '1.5'
                                        }"
                                    >
                                        {{ mediaTypeNoHeadlineMap.get(mention.mediaType) | localize }}
                                    </span>
                                }
                            </ng-template>
                            <!-- METADATA -->
                            @for (metadataType of data.styles.metadataTypes; track $index + metadataType) {
                                @if (metadataType === metadataTypes.author && mention.contactName) {
                                    <p
                                        class="agpr-mentionGridDisplay-author"
                                        [ngStyle]="{
                                            'text-align': data.styles.metadataFont.alignment,
                                            'font-weight': data.styles.metadataFont.bold ? 'bold' : 'normal',
                                            'color': data.styles.metadataFont.color,
                                            'font-family': data.styles.metadataFont.fontFamily,
                                            'font-size': data.styles.metadataFont.fontSize,
                                            'font-style': data.styles.metadataFont.italics ? 'italic' : 'normal',
                                            'text-decoration': data.styles.metadataFont.underlined ? 'underline' : 'none',
                                            'display': 'block'
                                        }"
                                    >
                                        {{ mention.contactName }}
                                    </p>
                                }
                                @if (metadataType === metadataTypes.publishedDate && mention.publishedDate) {
                                    <p
                                        class="agpr-mentionGridDisplay-date"
                                        [ngStyle]="{
                                            'text-align': data.styles.metadataFont.alignment,
                                            'font-weight': data.styles.metadataFont.bold ? 'bold' : 'normal',
                                            'color': data.styles.metadataFont.color,
                                            'font-family': data.styles.metadataFont.fontFamily,
                                            'font-size': data.styles.metadataFont.fontSize,
                                            'font-style': data.styles.metadataFont.italics ? 'italic' : 'normal',
                                            'text-decoration': data.styles.metadataFont.underlined ? 'underline' : 'none',
                                            'display': 'block'
                                        }"
                                    >
                                        {{ mention.publishedDate | agprDateString: data.styles.dateFormat: data.styles.timezone : data.styles.locale }}
                                    </p>
                                }
                                @if (metadataEnumToMentionField.get(metadataType)) {
                                    <p
                                        class="agpr-mentionGridDisplay-metadataContainer"
                                        [ngStyle]="{
                                            'text-align': data.styles.metadataFont.alignment,
                                            'font-weight': data.styles.metadataFont.bold ? 'bold' : 'normal',
                                            'color': data.styles.metadataFont.color,
                                            'font-family': data.styles.metadataFont.fontFamily,
                                            'font-size': data.styles.metadataFont.fontSize,
                                            'font-style': data.styles.metadataFont.italics ? 'italic' : 'normal',
                                            'text-decoration': data.styles.metadataFont.underlined ? 'underline' : 'none',
                                            'display': 'block'
                                        }"
                                    >
                                        <span class="agpr-mentionGridDisplay-metadataContainer-label">
                                            {{'Mention.customization.metadataType.' + metadataType | localizeFromParams : data.styles?.locale}}:
                                        </span>
                                        @if (metadataType === metadataTypes.ave) {
                                            <span> {{ (mention.adValueUsd || mention.adValueUsd === 0) ? (mention.adValueUsd | CurrencyConversion: true: data.styles.preferredCurrency): 'N/A' }} </span>
                                        } @else if (metadataType === metadataTypes.sentiment) {
                                            <span>{{ sentimentMap[mentionId] | localizeFromParams : data.styles?.locale }}</span>
                                        } @else if (mention[metadataEnumToMentionField.get(metadataType)] || mention[metadataEnumToMentionField.get(metadataType)] === 0) {
                                            <span> {{ mention[metadataEnumToMentionField.get(metadataType)] }} </span>
                                        } @else {
                                            <span> N/A </span>
                                        }
                                    </p>
                                }

                            }
                            @if (data.styles.metadataTypes.includes(metadataTypes.engagement) && mention.socialData) {
                                @for (engagementData of engagementDataMap[mentionId]; track engagementData.label) {
                                    <p
                                        class="agpr-mentionGridDisplay-metadataContainer"
                                        [ngStyle]="{
                                            'text-align': data.styles.metadataFont.alignment,
                                            'font-weight': data.styles.metadataFont.bold ? 'bold' : 'normal',
                                            'color': data.styles.metadataFont.color,
                                            'font-family': data.styles.metadataFont.fontFamily,
                                            'font-size': data.styles.metadataFont.fontSize,
                                            'font-style': data.styles.metadataFont.italics ? 'italic' : 'normal',
                                            'text-decoration': data.styles.metadataFont.underlined ? 'underline' : 'none',
                                            'display': 'block'
                                        }"
                                    >
                                        <span class="agpr-mentionGridDisplay-metadataContainer-label"> {{ engagementData.label | localizeFromParams : data.styles?.locale }}: </span>
                                        <span> {{ (engagementData.value || engagementData.value === 0) ? engagementData.value : 'N/A' }} </span>
                                    </p>
                                }
                            }

                            @if (data.styles.notes) {
                                <p
                                    [ngStyle]="{
                                        'text-align': data.styles.notesFont.alignment,
                                        'font-weight': data.styles.notesFont.bold ? 'bold' : 'normal',
                                        'color': data.styles.notesFont.color,
                                        'font-family': data.styles.notesFont.fontFamily,
                                        'font-size': data.styles.notesFont.fontSize,
                                        'font-style': data.styles.notesFont.italics ? 'italic' : 'normal',
                                        'text-decoration': data.styles.notesFont.underlined ? 'underline' : 'none',
                                        'display': 'block',
                                        'line-height': '1.5'

                                    }"
                                >
                                    <span> {{ data.styles.notesLabel }} </span>
                                    <span> {{ mention.note }} </span>
                                </p>
                            }

                            @if (data.styles.mentionContent !== mentionContentTypes.headlineOnly) {
                                @if (data.styles.highlightKeywords) {
                                    <div
                                        class="agpr-mentionGridDisplay-main-snippet"
                                        [innerHtml]="(bodyTextMap[mentionId]
                                            | indexHighlightApi :
                                                ((data.styles.mentionContent === mentionContentTypes.lead) || (data.styles.mentionContent === mentionContentTypes.fullText)
                                                ? mention.contexualKeywordIndices : mention.summaryContextualKeywordIndices) : highlightKeywordsMap[mentionId]
                                            | indexHighlightSup
                                            | highlightKeywords: highlightKeywordsMap[mentionId]
                                        )"
                                        [ngStyle]="{
                                            'text-align': data.styles.snippetFont.alignment,
                                            'font-weight': data.styles.snippetFont.bold ? 'bold' : 'normal',
                                            'color': data.styles.snippetFont.color,
                                            'font-family': data.styles.snippetFont.fontFamily,
                                            'font-size': data.styles.snippetFont.fontSize,
                                            'font-style': data.styles.snippetFont.italics ? 'italic' : 'normal',
                                            'text-decoration': data.styles.snippetFont.underlined ? 'underline' : 'none',
                                            'display': 'block',
                                            'line-height': '1.5'
                                        }"
                                    ></div>
                                } @else {
                                    <div
                                        class="agpr-mentionGridDisplay-snippet"
                                        [ngStyle]="{
                                            'text-align': data.styles.snippetFont.alignment,
                                            'font-weight': data.styles.snippetFont.bold ? 'bold' : 'normal',
                                            'color': data.styles.snippetFont.color,
                                            'font-family': data.styles.snippetFont.fontFamily,
                                            'font-size': data.styles.snippetFont.fontSize,
                                            'font-style': data.styles.snippetFont.italics ? 'italic' : 'normal',
                                            'text-decoration': data.styles.snippetFont.underlined ? 'underline' : 'none',
                                            'display': 'block',
                                            'line-height': '1.5'
                                        }"
                                    >
                                        {{ bodyTextMap[mentionId] }}
                                    </div>
                                }
                            }

                            @if (data.styles.showInsights && mention.insights?.length > 0) {
                                @for(insight of mention.insights; track insight) {
                                    @if (insight.isPreferred) {
                                        <div
                                            class="agpr-mentionGridDisplay-insight"
                                            [ngStyle]="{
                                                'text-align': data.styles.insightsFont.alignment,
                                                'font-weight': data.styles.insightsFont.bold ? 'bold' : 'normal',
                                                'color': data.styles.insightsFont.color,
                                                'font-family': data.styles.insightsFont.fontFamily,
                                                'font-size': data.styles.insightsFont.fontSize,
                                                'font-style': data.styles.insightsFont.italics ? 'italic' : 'normal',
                                                'text-decoration': data.styles.insightsFont.underlined ? 'underline' : 'none',
                                                'display': 'block',
                                                'line-height': '1.5'
                                            }"
                                        >
                                            @if (data.styles.displayInsightsName) {
                                                <span class="agpr-mentionGridDisplay-insight-label">
                                                    {{ data.styles.insightsNameDisplay === insightsNameEnum.insightsName ?  insight.name + ':' : data.styles.customInsightsName }}
                                                </span>
                                            }

                                            <div
                                                class="agpr-mentionGridDisplay-insight-content"
                                                [innerHTML]="insight.content | setUlStyle | sanitizeHtml"
                                            ></div>
                                        </div>

                                    }
                                }
                            }

                        </div>
                        @if (data.styles.metadataTypes.includes(metadataTypes.image) && thumbnailImageMap.get(mentionId); as imageSrc) {
                            <div class="agpr-mentionGridDisplay-imgContainer">
                                <img
                                    class="agpr-mentionGridDisplay-img"
                                    [ngClass]="{
                                        'agpr-mentionGridDisplay-img--thumbnail': data.styles.imageSize === imageSizeEnum.thumbnail
                                    }"
                                    [src]="imageSrc"
                                    (error)="onImageError($event, mentionId)"
                                />
                            </div>
                        }
                    </li>
                }
                @if (data.mentionPreviewCount) {
                    <li
                        class="agpr-mentionGridDisplay-card agpr-mentionGridDisplay-placeHolderCard"
                        [ngClass]="{
                            'agpr-mentionGridDisplay-placeHolderCardfullHeight': data?.styles?.cardHeight !== mentionCardHeightEnum.flexible
                        }"
                    >
                        <a
                            class="agpr-mentionGridDisplay-viewAllLink--center"
                            (click)="viewAllMentions()"
                            [ngStyle]="{'color': data.styles.heading.color}"
                        >
                            <i class="fa-regular fa-layer-group"></i>
                            <span> {{ 'Briefings.mentionList.viewMentionLink' | localize }} </span>
                        </a>
                    </li>
                }
            </ul>

            @if (data.styles.includeBackToTopLinks) {
                <a
                    (click)="scrollToTop()"
                    [ngStyle]="{
                        'text-align': data.styles.backToTopLinksFont.alignment,
                        'font-weight': data.styles.backToTopLinksFont.bold ? 'bold' : 'normal',
                        'color': data.styles.backToTopLinksFont.color,
                        'font-family': data.styles.backToTopLinksFont.fontFamily,
                        'font-size': data.styles.backToTopLinksFont.fontSize,
                        'font-style': data.styles.backToTopLinksFont.italics ? 'italic' : 'normal',
                        'text-decoration': data.styles.backToTopLinksFont.underlined ? 'underline' : 'none',
                        'display': 'block',
                        'line-height': '1.5',
                        'cursor': 'pointer'
                    }"
                >
                    <span> {{ data.styles.backToTopLinksLabel }} </span>
                </a>
            }

        </div>
    }
}